<template>
  <div class="page">
    <div class="page__content u-space u-space--large">
      <h1 class="h2">Click on your name to start</h1>
      <template v-if="players.length">
        <ul class="u-space">
          <li v-for="player in players" :key="player.id">
            <a :href="`/game/${$route.params.id}/${player.id}`">
              <strong>{{ player.name }}</strong>
            </a>
          </li>
        </ul>
        <div>
          Share this link with your friends:
          <a :href="url">{{ url }}</a>
        </div>

        <button type="button" @click="share">
          <strong>Share/Copy</strong>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      players: []
    };
  },

  mounted() {
    return fetch(`${this.$store.state.API}/game/${this.$route.params.id}`)
      .then(x => x.json())
      .then(res => {
        this.players = res.players;
      })
      .catch(() => {});
  },

  computed: {
    url() {
      return `${window.location.href}`;
    }
  },

  methods: {
    copyToClipboard(str) {
      if (!document) return;

      const el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);

      const selection = document.getSelection();
      if (!selection) return;

      const selected =
        selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      window.dispatchEvent(new Event("onShareLinkCopy"));

      if (selected) {
        selection.removeAllRanges();
        selection.addRange(selected);
      }
    },

    async share() {
      const title = "Ticket to Ride";
      const text = "Play with " + this.players.map(x => x.name).join(", ");
      const url = window.location.href;

      if (!navigator.share) {
        this.copyToClipboard(url);
        return;
      }

      try {
        await navigator.share({
          title,
          text,
          url
        });
      } catch (e) {
        // console.log()
      }
    }
  }
};
</script>
